import { RouterProvider, createBrowserRouter, redirect, Navigate } from 'react-router-dom'
import NotFound from './pages/error/error404'
import InternalServerError from './pages/error/error500'
import Login from './pages/login'
import Main from './pages/main'
import Nav from './pages/main/nav'
import EnterpriseEntry from './pages/enterpriseEntry'
import PresentationVenue from './pages/presentationVenue'
import JobFairVenue from './pages/jobFairVenue'
import PresentationSlot from './pages/presentationSlot'
import JobFairSlotSlot from './pages/jobFairSlot'
import PresentationApplication from './pages/presentationApplication'
import JobFairApplication from './pages/jobFairApplication'
import EventConfig from './pages/eventConfig'


const interceptToken = () => {
    const token = localStorage.getItem('token')
    if (token) {
        throw redirect('/')
    }
    return null
}

const interceptNoToken = () => {
    const token = localStorage.getItem('token')
    if (!token) {
        throw redirect('/login')
    }
    return null
}

const router = createBrowserRouter([
    {
        path: '/login',
        element: <Login />,
        loader: () => interceptToken()
    },
    {
        path: '/',
        element: <Main />,
        children: [
            {
                path: '',
                element: <Nav />,
                children: [
                    {
                        path: '',
                        element: <Navigate to="enterprise_entry" />
                    },
                    {
                        path: 'enterprise_entry',
                        element: <EnterpriseEntry />,
                        loader: () => interceptNoToken()
                    },
                    {
                        path: 'presentation_venue',
                        element: <PresentationVenue />,
                        loader: () => interceptNoToken()
                    },
                    {
                        path: 'presentation_slot',
                        element: <PresentationSlot />,
                        loader: () => interceptNoToken()
                    },
                    {
                        path: 'job_fair_venue',
                        element: <JobFairVenue />,
                        loader: () => interceptNoToken()
                    },
                    {
                        path: 'job_fair_slot',
                        element: <JobFairSlotSlot />,
                        loader: () => interceptNoToken()
                    },
                    {
                        path: 'presentation_application',
                        element: <PresentationApplication />,
                        loader: () => interceptNoToken()
                    },
                    {
                        path: 'job_fair_application',
                        element: <JobFairApplication />,
                        loader: () => interceptNoToken()
                    },
                    {
                        path: 'event_config',
                        element: <EventConfig />,
                        loader: () => interceptNoToken()
                    }
                ],
            },
        ],
    },
    {
        path: '/500',
        element: <InternalServerError />
    },
    {
        path: '/*',
        element: <NotFound />
    }
])

export default function Router() {
    return (
        <RouterProvider router={router} />
    )
}
